module.exports = __webpack_public_path__ + "assets/19169e44f763b8b13c3b9448196fa5e0.mp3";